import { createFileRoute } from "@tanstack/react-router";
import { FormBuilderPanel } from "@/features/form-editor/components/form-builder/form-builder-panel";

export const Route = createFileRoute(
	"/_authenticated/(admin-app)/_admin/admin/configuration/recordTypes/$recordTypeId/full/form/",
)({
	component: AdminRecordTypeFullFormBuilderRoute,
});

function AdminRecordTypeFullFormBuilderRoute() {
	return (
		<div className="flex min-h-0 flex-1 flex-col px-4">
			<FormBuilderPanel />
		</div>
	);
}
